import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/global.css';
import { startPerformanceTelemetry } from './app/performanceTelemetry';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root was not found in index.html');
}

startPerformanceTelemetry();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
